import axios from 'axios';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
});

export async function loginWithGoogle(credential) {
  const response = await httpClient.post('/auth/google', { credential });
  return response.data?.data;
}
